import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactPlayer from 'react-player'

import { toggleVideo } from '../actions'
import { DEFAULT_VIDEO_STATE } from '../reducers/video'

class FullScreenVideo extends Component {
    constructor(props) {
        super(props)
        this.play = this.play.bind(this)
        this.stop = this.stop.bind(this)
    }
    play() {
        this.props.toggleVideo(true)
    }
    stop() {
        this.props.toggleVideo(false)
    }
    componentWillUnmount() { 
        this.props.toggleVideo(false)
    }
	render() {
		return ( 
			<div className="video-player responsive-embed widescreen">
				<ReactPlayer 
    		    	url={this.props.id}
    		    	controls={true}
                    onStart={this.play}
                    onPlay={this.play}
                    onPause={this.stop}
                    onEnded={this.stop}
                    onError={this.stop} />
			</div>
		)
	}
}

function mapStateToProps(state) {
    const playing = state.video.playing || state.video[DEFAULT_VIDEO_STATE].playing
    return {
        playing: playing,
    }
}

export default connect(mapStateToProps, { toggleVideo })(FullScreenVideo)


// WEBPACK FOOTER //
// ./src/components/VideoPlayer.js